import { ExperimentId } from './experiments';

export type FolderId = string;

export const UNCATEGORIZED_FOLDER_NAME = 'Uncategorized';

export interface PreviewLink {
  id: string;
}

export enum VisibilityState {
  Off = 'Off',
  Live = 'Live',
}

export enum ContentType {
  Inline = 'Inline',
  Modal = 'Modal',
  HotspotGroup = 'HotspotGroup',
  Tour = 'Tour',
  Banner = 'Banner',
}

export type ApplicationId = string;
export type ContentId = string;
export type Slug = string;
export type CommitId = string;
export type SegmentId = string;
export type DocumentId = number;
export type ContentSlug = string;

export interface ContentMetadata {
  id: ContentId;
  name: string;
  slug: ContentSlug;
  ownerId: string;
  defaultDocumentId?: DocumentId;
  folderId?: FolderId;
  description?: string;
  lastPublishedAt?: string;
  archivedAt?: string;
  lastModifiedAt?: string;
  entityPermissionId?: number;
  previewLink?: PreviewLink;
  createdAt: string;
  visibilityState: VisibilityState;
  contentType: ContentType;
  personalisationMode?: 'Segments' | 'Experimentation';
  experimentId?: ExperimentId;
}

export interface ContentSegmentDocumentMetadata {
  contentSegmentDocumentId: number;
  segmentId: string;
  documentId: DocumentId;
  sortIndex: number;
  lastModifiedAt?: string;
  lastPublishedAt?: string;
}

export interface ContentSegments {
  id: ContentId;
  slug?: ContentSlug;
  defaultDocumentId?: DocumentId;
  defaultDocumentLastModifiedAt?: string;
  defaultDocumentLastPublishedAt?: string;
  segmentDocuments: ContentSegmentDocumentMetadata[];
}
